const logger = (store) => (next) => (action) => {
  console.group("Dispatching : ", action.type);
  console.log("Current state: ", store.getState());
  console.log("Action is: ", action);
  let result = next(action);
  console.log("Next state: ", store.getState());
  console.groupEnd();
  return result;
};

export default logger;
